import axiosNextGen from '../../../config/axios-nextgen';

export async function getAssociatedUsers(widgetKey) {
    const response = await axiosNextGen.get(`/api/users/accessible`);
    return response.data;
}

const userService = {
    getAssociatedUsers
};

export default userService;
